import type { SVGProps } from 'react';
const SvgRoofing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#roofing_svg__a)">
      <path
        fill="currentColor"
        d="M13 18h-2v-2h2v2Zm2-4H9v6h6v-6Zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7Z"
      />
    </g>
    <defs>
      <clipPath id="roofing_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRoofing;
